module.exports = __webpack_public_path__ + "media/categories/1033-9108ae45.svg";